import { ref, reactive, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-df00a158"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wechat-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const _hoisted_3 = {
  class: "flex-content"
};
const __default__ = {
  name: 'OrdinaryDouyinGame'
};
import SvgIcon from '@/components/SvgIcon.vue';
import { calDivide, getSysconfig } from '@/api/payManage/accountManage';
import { awaitWrap, OK } from '@/common';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const rateList = ref([]); // 分成比例列表
    const douyinRateList = ref([{
      label: '5%',
      value: '0.05'
    }, {
      label: '6%',
      value: '0.06'
    }]); // 抖音增值税税率列表
    const OrdinaryGameRef = ref();
    const OrdinaryGameForm = reactive({
      pkg: '',
      channelRate: '0.05',
      valueAddedTaxRateId: '0.05',
      rate: '0.6',
      mchName: '',
      appSecret: '',
      signKey: '',
      appId: ''
    });
    const validateForm = () => {
      var _OrdinaryGameRef$valu;
      (_OrdinaryGameRef$valu = OrdinaryGameRef.value) === null || _OrdinaryGameRef$valu === void 0 || _OrdinaryGameRef$valu.validate().then(() => {
        emit('submitForm', OrdinaryGameForm);
      }).catch(e => void 0);
    };
    const getDouyinRateList = async () => {
      try {
        const {
          data,
          code
        } = await getSysconfig();
        if (code === OK) {
          douyinRateList.value = data.map(item => {
            return {
              ...item,
              value: item.id
            };
          });
        }
      } catch (e) {}
    }; // 获取抖音增值税税率列表
    const handleCalDivide = async () => {
      var _props$detailForm, _OrdinaryGameForm$rat, _props$detailForm2, _props$detailForm3, _props$detailForm4, _props$detailForm5, _props$detailForm6;
      const [err, data] = await awaitWrap(calDivide({
        accountId: (_props$detailForm = props.detailForm) === null || _props$detailForm === void 0 ? void 0 : _props$detailForm.accountId,
        channelData: {
          channelData: {
            rate: (_OrdinaryGameForm$rat = OrdinaryGameForm.rate) !== null && _OrdinaryGameForm$rat !== void 0 ? _OrdinaryGameForm$rat : 0.6
          },
          channelType: (_props$detailForm2 = props.detailForm) === null || _props$detailForm2 === void 0 ? void 0 : _props$detailForm2.mainChannelType,
          dbtId: (_props$detailForm3 = props.detailForm) === null || _props$detailForm3 === void 0 ? void 0 : _props$detailForm3.dbtId,
          id: (_props$detailForm4 = props.detailForm) === null || _props$detailForm4 === void 0 ? void 0 : _props$detailForm4.id,
          pkg: (_props$detailForm5 = props.detailForm) === null || _props$detailForm5 === void 0 ? void 0 : _props$detailForm5.pkg
        },
        mchId: (_props$detailForm6 = props.detailForm) === null || _props$detailForm6 === void 0 ? void 0 : _props$detailForm6.mchId
      }));
      if (data) {
        if (data.code === OK) {
          OrdinaryGameForm.divide = data.data.divide;
        }
      }
      if (err) {}
    }; // 计算分成比例
    watch(() => props.detailForm, n => {
      if (n) {
        OrdinaryGameForm.mchName = n.mchName;
        OrdinaryGameForm.pkg = n.pkg;
        OrdinaryGameForm.appSecret = n.appSecret;
        OrdinaryGameForm.appId = n.appId;
        OrdinaryGameForm.signKey = n.signSecret;
        OrdinaryGameForm.valueAddedTaxRateId = n.valueAddedTaxRateId;
        OrdinaryGameForm.rate = n.rate;
        rateList.value = n.rateList;
        if (n.rate) {
          handleCalDivide();
        }
      }
    }, {
      deep: true
    });
    expose({
      validateForm,
      getDouyinRateList,
      handleCalDivide
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        class: "huawei-form",
        model: OrdinaryGameForm,
        ref_key: "OrdinaryGameRef",
        ref: OrdinaryGameRef,
        rules: __props.rules,
        name: "ordinary-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: OrdinaryGameForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => OrdinaryGameForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "mchName",
          label: "商户主体："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: OrdinaryGameForm.mchName,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => OrdinaryGameForm.mchName = $event),
            disabled: "",
            maxlength: 200
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "valueAddedTaxRateId",
          label: "增值税税率："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: OrdinaryGameForm.valueAddedTaxRateId,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => OrdinaryGameForm.valueAddedTaxRateId = $event),
            options: douyinRateList.value,
            disabled: ""
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "rate",
          label: "分成比例："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: OrdinaryGameForm.rate,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => OrdinaryGameForm.rate = $event),
            options: rateList.value,
            onChange: handleCalDivide
          }, null, 8, ["value", "options"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("一般内购收益政策：60%；减免版内购收益政策：90%")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_input, {
            value: OrdinaryGameForm.divide,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => OrdinaryGameForm.divide = $event),
            disabled: ""
          }, null, 8, ["value"])])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: OrdinaryGameForm.appId,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => OrdinaryGameForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appSecret",
          label: "App secret："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: OrdinaryGameForm.appSecret,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => OrdinaryGameForm.appSecret = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "signKey",
          label: "签名密钥："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: OrdinaryGameForm.signKey,
            "onUpdate:value": _cache[7] || (_cache[7] = $event => OrdinaryGameForm.signKey = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});